const processScripts = (body: string, deferLoadScripts: boolean) => {
    if (!deferLoadScripts) {
        return {
            content: body,
            loadScripts: () => {},
        };
    }
    const scripts = [];
    const content = body.replace(/<script\b([^>]*)>([\s\S]*?)<\/script>/gi, (match, attrs = '', content = '') => {
        const [_, src] = attrs.match(/src="([^"]*)"/) || [];
        scripts.push({ src, content });
        return '';
    });
    const loadScripts = () => {
        scripts.forEach(({src, content}) => {
            const script = document.createElement('script');
            if (src) {
                script.src = src;
            } else {
                script.innerHTML = content;
            }
            document.body.appendChild(script);
        });
    };
    return {
        content,
        loadScripts,
    };
}

export default processScripts;